/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.models {


    export interface IAuthenticationStatus {
        isAuthenticated: boolean;
        isAdmin: boolean;
        isConfigurator: boolean;
        isMaintenanceAdmin: boolean;
        signOutUrl: string;
    }

    export class LayoutModel {

        activeProcessTypes: Wars.Domain.Model.ProcessType[];
        menuItems: Wars.Domain.Model.Dtos.MenuItemDto[] = [];
        siteConfiguration: Wars.Domain.Model.Dtos.SiteConfigurationDto;
        authentication: IAuthenticationStatus;
        defaultSignOutPath = "";
        notificationCount: any;
        public showNavigation: boolean;
        public showFooter: boolean;
        contentPageDtos: Wars.Domain.Model.Dtos.ContentPageDto[];
        public showUserAdministration: boolean = false;
        private isUserPopoverOpen: boolean;
        //killTokenUrl = "";

        constructor(
            private controllerScope: angular.IScope,
            private userAdministrationService: services.UserAdministrationService,
            private windowService: angular.IWindowService,
            private localStorageService: any,
            private signalrService: services.ISignalrService,
            private httpService: angular.IHttpService,
            private rootScopeService: angular.IRootScopeService,
            private locationService: angular.ILocationService,
            private processTypeService: services.ProcessTypeService,
            private menuItemService: services.MenuItemService,
            private emailService: services.EmailService,
            private siteConfigurationService: services.SiteConfigurationService,
            private siteInitializationService: services.SiteInitializationService,
            private userService: services.UserService,
            private authService: any,
            private testService: services.TestService,
            private $q: angular.IQService) {

            var self = this;

            self.authentication = {
                isConfigurator: false,
                isAdmin: false,
                isAuthenticated: false,
                isMaintenanceAdmin: false,
                signOutUrl: undefined
            };

            this.isUserPopoverOpen = false; 

            if (!self.authService.authentication.isAuth) {
                //if the client is not authenticated, attempt to get an authentication provider token since this could be the redirect from an external login source (STS)
                self.httpService.get("./api/Authenticate/GetToken")
                    .success((result: any) => {
                        if (result.authenticated) {
                            //we have a STS token, so this is a re-bootstrap after STS signin 
                            self.authService.providerLogin(result.token);
                            var data = {
                                signOutUrl: result.signOutUrl,
                                afterSignInPath: "/home"
                            };
                            self.authService.signOutData = data;
                            //if (data.signOutUrl) {
                            //    //immediately signout from STS since we manage our own token from here
                            //    self.windowService.location.assign(data.signOutUrl);
                            //} else {
                            //    //initialize full login since we're not signing out from STS - we don't do this part anymore
                                self.basicInitialization();
                                self.userAuthenticated();
                            //}
                        } else {
                            //not authenticated and don't have a token, so do basic initialization - STS and social logins go through here on initial bootstrap
                            self.basicInitialization();
                        }
                    });
            } else {
                //must be a re-bootstrap (refresh or redirect after STS signout call)
                self.basicInitialization();
                self.userAuthenticated();
            }
        }

        basicInitialization() {
            var self = this;

            //show nav bar
            self.showNavigation = true;

            //this is only invoked by a social login since STS logins always re-bootstrap due to redirects
            self.rootScopeService.$on("userAuthenticated", (event, data) => {
                self.userAuthenticated();
            });

            self.getSiteConfigurationForExecution();

            self.getMenuItems();

            self.rootScopeService.$on("resetMenus", (event) => {
                self.getMenuItems();
            });

            //TODO: Cody, please check this when testing payments
            if (self.locationService.path() === "/InitiatePayment") {
                self.showNavigation = false;
                self.showFooter = false;
            }

            self.rootScopeService.$on("userNotAuthorized",
                (event) => {
                    self.localStorageService.remove("authorizationData");
                    self.authentication.isAuthenticated = false;
                    self.authentication.isAdmin = false;
                    self.authentication.isConfigurator = false;
                    self.authentication.isMaintenanceAdmin = false;
                    self.rootScopeService.$broadcast("resetMenus");
                    self.locationService.url("/login");
                });

        }

        userAuthenticated() {
            var self = this;

            //set auth data
            self.authentication.isAuthenticated = self.authService.authentication.isAuth;
            self.authentication.isAdmin = self.authService.authentication.isAdmin;
            self.authentication.isConfigurator = self.authService.authentication.isConfigurator;
            self.authentication.isMaintenanceAdmin = self.authService.authentication.isMaintenanceAdmin;
            self.authentication.signOutUrl = self.defaultSignOutPath;

            //for admin or configurator - reload active process types and hook up unsaved changes confirmation
            if (self.authentication.isAdmin || self.authentication.isConfigurator) {
                self.reloadActiveProcessTypes();
                self.hookUpUnsavedChangesConfirmation();
                self.rootScopeService.$on("process-configuration-activated", () => {
                    self.reloadActiveProcessTypes();
                });
            }

            //get and listen for email notifications
            self.getEmailNotificationCount();
            self.signalrService.listen(self.controllerScope).then((listener) => {
                listener.onClientReceivedWarsNotification((notificationCount) => {
                    self.warsNotificationReceived(notificationCount);
                });
            });
            //this clears notification count
            self.rootScopeService.$on("notificationCountRefresh", (notificationRefresh, notifications) => {
                self.warsNotificationReceived(notifications);
            });

            //get editable content pages
            self.getEditiableContentPages();

            //get user's grant authorizations for user administration
            self.userAdministrationService.getUserGrantAuthorizations()
                .then((authorization) => {
                    if (authorization && authorization.options.length > 0) {
                        self.showUserAdministration = true;
                    }
                });

            //check if we need to redirect after logging in because of a deep link scenario
            var redirect = localStorage.getItem('redirectAfterLogin');
            if (redirect != null) {
                localStorage.removeItem('redirectAfterLogin');
                this.locationService.url(redirect);
            } else {
                if ((self.locationService.url() === "/home" || self.locationService.url() === "/login") ||
                    (self.siteConfiguration !== null && self.siteConfiguration !== undefined && self.siteConfiguration.homeContentPageId !== null && self.siteConfiguration.homeContentPageId !== undefined)) {
                    self.siteInitializationService.getRoute()
                        .then((route) => {
                            self.locationService.url(route);
                        });
                }
            }

            //set handler for signout
            self.rootScopeService.$on("userSignOut", (event, notifyServerHubOfDisconnect) => {
                var promises = [];

                promises.push(this.testService.endImpersonation());
                promises.push(this.testService.endChangeDateTime());

                this.$q.all(promises).then(() => {
                    self.signalrService.stopConnection(notifyServerHubOfDisconnect);
                    self.localStorageService.remove("authorizationData");
                    self.authentication.isAuthenticated = false;
                    self.authentication.isAdmin = false;
                    self.authentication.isConfigurator = false;
                    self.authentication.isMaintenanceAdmin = false;
                    redirect = localStorage.getItem('redirectAfterLogin');
                    if (redirect != null) {
                        localStorage.removeItem('redirectAfterLogin');
                    }
                    if (self.siteConfiguration !== null && self.siteConfiguration !== undefined && self.siteConfiguration.homeContentPageId !== null && self.siteConfiguration.homeContentPageId !== undefined) {
                        self.locationService.url("ContentPage/" + self.siteConfiguration.homeContentPageId);
                    } else {
                        self.locationService.url("/home");
                    }
                    if (self.authService.signOutData) {
                        var soUrl = self.authService.signOutData.signOutUrl;
                        self.authService.signOutData = undefined;
                        self.windowService.location.assign(soUrl);    
                    }
                });
            });
        }

        reloadActiveProcessTypes(): void {
            var self = this;
            self.processTypeService.getActiveProcessTypes().then(result => {
                self.activeProcessTypes = result;
            });
        }

        signIn(): void {
            var self = this;
            self.locationService.url("/login");
        }

        signOut(): void {
            var self = this;
            self.rootScopeService.$broadcast("userSignOut", true);
        }

        getMenuItems() {
            var self = this;
            self.siteInitializationService.getMenuItems().then(r => {
                self.menuItems = r;
            });
        }

        getSiteConfigurationForExecution() {
            var self = this;
            self.siteConfigurationService.getSiteConfigurationForExecution()
                .then(s => {
                    self.siteConfiguration = s;
                    self.showFooter = s.showFooter;
                    if (self.locationService.url() === "/home" && s.homeContentPageId !== null && s.homeContentPageId !== undefined) {
                        self.locationService.url("ContentPage/" + s.homeContentPageId);
                    }
                });
        }

        getEmailNotificationCount() {
            var self = this;
            self.emailService.getEmailNotificationCount()
                .then((notificationCount) => {
                    self.notificationCount = notificationCount;
                });
        }

        getEditiableContentPages() {
            var self = this;
            self.siteInitializationService.getEditiableContentPages()
                .then((contentPages) => {
                    self.contentPageDtos = contentPages;
                });
        }

        hookUpUnsavedChangesConfirmation() {
            var self = this;
            this.rootScopeService.$on('$locationChangeStart', (event) => {
                if (self.processTypeService.hasChanges()) {
                    var confirmation = confirm("You have unsaved changes are you sure you wish to discard them and navigate to another page?");
                    if (confirmation) {
                        self.processTypeService.clearCache();
                    } else {
                        event.preventDefault();
                    }
                }
            });
        }

        warsNotificationReceived(notificationCount) {
            var self = this;
            self.notificationCount = notificationCount;
        }

        private getCurrentUserId(): string {
            var userId = this.userService.getLoggedInUserId();
            return userId;
        }

        private openUserPopover(): void {
            this.isUserPopoverOpen = true;
        }
    }
}